import React from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { ASSETS } from "../i18n/translations";

export default function About() {
  const { t } = useLanguage();

  return (
    <section id="about" data-testid="about-section" className="py-20 md:py-24 bg-[#e8ecf3]">
      <div className="px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-10 items-end">
          <div className="col-span-12 md:col-span-5">
            <div className="relative aspect-square overflow-hidden border border-[#1d428a]/15 bg-white">
              <img
                src={ASSETS.logo}
                alt="Schweizer Planmanufaktur GmbH"
                className="w-full h-full object-contain p-10 md:p-14"
                loading="lazy"
              />
              <div className="absolute top-4 left-4 font-mono-tech text-[#1d428a] bg-white px-2 py-1 border border-[#1d428a]/15">
                CH · GMBH · EST.
              </div>
              <div className="absolute bottom-4 right-4 font-mono-tech text-white bg-[#df4661] px-2 py-1">
                MONTIEREN · BAUEN · WARTEN
              </div>
            </div>
          </div>

          <div className="col-span-12 md:col-span-7 md:pl-8">
            <div className="font-mono-tech text-[#1d428a] mb-6">
              <span className="inline-block w-2 h-2 bg-[#df4661] mr-3 align-middle" />
              {t.about.eyebrow}
            </div>
            <h2 data-testid="about-title" className="font-display text-4xl md:text-5xl lg:text-6xl text-[#0A0A0A]">
              {t.about.title}
            </h2>
            <p className="mt-6 text-[#0A0A0A] text-sm md:text-base leading-relaxed max-w-2xl">
              {t.about.p1}
            </p>
            <p className="mt-3 text-[#5A6270] text-sm md:text-base leading-relaxed max-w-2xl">
              {t.about.p2}
            </p>

            <ul className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-px bg-[#1d428a]/15 border border-[#1d428a]/15">
              {[t.about.bullet_1, t.about.bullet_2, t.about.bullet_3].map((b, i) => (
                <li key={i} className="bg-white p-4">
                  <div className="font-mono-tech text-[#df4661]">0{i + 1}</div>
                  <div className="mt-1.5 font-display-mid text-base text-[#1d428a]">{b}</div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
